import React from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const AddCategories = () => {
  const categories = [
    {
      name: "Student Plans",
      description: "Affordable and diverse meal options featuring variety rice, poriyal, and simple curries. Perfect for students seeking delicious, budget-friendly meals.",
      imageUrl: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop",
      price: 1800,
      mealsPerDay: 3,
      cuisineType: "Mixed",
      isAvailable: true
    },
    {
      name: "South Indian",
      description: "Authentic South Indian cuisine featuring dosas, idlis, vadas, and traditional curries. Perfect for those who love the rich flavors of South India.",
      imageUrl: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400&h=400&fit=crop",
      price: 2500,
      mealsPerDay: 3,
      cuisineType: "South Indian",
      isAvailable: true
    },
    {
      name: "North Indian",
      description: "Rich and flavorful North Indian dishes including rotis, curries, and traditional breads. Experience the authentic taste of North India.",
      imageUrl: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400&h=400&fit=crop",
      price: 2800,
      mealsPerDay: 3,
      cuisineType: "North Indian",
      isAvailable: true
    },
    {
      name: "Diet Plans",
      description: "Healthy and balanced meals designed for weight management and fitness goals. Nutritious options for health-conscious individuals.",
      imageUrl: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=400&fit=crop",
      price: 3200,
      mealsPerDay: 3,
      cuisineType: "Diet",
      isAvailable: true
    },
    {
      name: "Premium Plans",
      description: "Gourmet meals with premium ingredients and diverse cuisines. Perfect for those who want restaurant-quality food at home.",
      imageUrl: "https://images.unsplash.com/photo-1504674900240-9a9049b7d8ce?w=400&h=400&fit=crop",
      price: 4500,
      mealsPerDay: 3,
      cuisineType: "Premium",
      isAvailable: true
    }
  ];

  const addCategories = async () => {
    try {
      for (const category of categories) {
        await addDoc(collection(db, 'categories'), category);
        console.log(`Added category: ${category.name}`);
      }
      alert('All categories added successfully!');
    } catch (error) {
      console.error('Error adding categories:', error);
      alert('Error adding categories. Please check console.');
    }
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Add Categories to Database</h2>
      <p>This will add the main categories (like Student Plans, South Indian, etc.) to the categories collection.</p>
      <button 
        onClick={addCategories}
        style={{
          padding: '12px 24px',
          backgroundColor: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Add Categories
      </button>
    </div>
  );
};

export default AddCategories;
